import React from 'react';
import Modal from '../../../components/Modal';
import { btn, primaryBtn, inputStyle, helperTextStyle } from './styles';

export default function ResignDateModal({ editHook, entityLabel }) {
  const {
    deactivateTarget,
    deactivateDate,
    setDeactivateDate,
    deactivateSaving,
    closeDeactivateModal,
    submitDeactivate,
  } = editHook;

  const open = Boolean(deactivateTarget);
  const targetName = deactivateTarget?.name || entityLabel;

  return (
    <Modal
      open={open}
      title={`${entityLabel} 퇴사 처리`}
      icon="📅"
      onClose={closeDeactivateModal}
      width="min(420px, calc(100vw - 32px))"
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <button type="button" style={btn} disabled={deactivateSaving} onClick={closeDeactivateModal}>
            취소
          </button>
          <button type="button" style={primaryBtn} disabled={deactivateSaving || !deactivateDate} onClick={submitDeactivate}>
            {deactivateSaving ? '처리 중...' : '퇴사 처리'}
          </button>
        </div>
      )}
    >
      <div style={{ display: 'grid', gap: 12 }}>
        <div style={{ display: 'grid', gap: 4 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text)' }}>{targetName}</div>
          <div style={helperTextStyle}>퇴사일을 달력에서 선택하면 해당 날짜로 퇴사 처리됩니다.</div>
        </div>
        <label style={{ display: 'grid', gap: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--text-muted)' }}>퇴사일자</span>
          <input
            type="date"
            style={{ ...inputStyle, width: '100%' }}
            value={deactivateDate}
            onChange={(event) => setDeactivateDate(event.target.value)}
            autoFocus
          />
        </label>
      </div>
    </Modal>
  );
}
